import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private requests: any[] = [];
  private refreshInProgress = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('/public/')) {
      return next.handle(req);
    }

    const observable = new Observable<HttpEvent<any>>((subscriber) => {
      const originalRequestSubscription = next.handle(req).subscribe(
        (response) => {
          subscriber.next(response);
        },
        (err) => {
          if (err.status === 401) {
            this.handleUnauthorizedError(subscriber, req);
          } else {
            subscriber.error(err);
          }
        },
        () => {
          subscriber.complete();
        },
      );

      return () => {
        originalRequestSubscription.unsubscribe();
      };
    });

    return observable;
  }

  private handleUnauthorizedError(
    subscriber: Subscriber<any>,
    request: HttpRequest<any>,
  ) {
    this.requests.push({ subscriber, request });
    if (!this.refreshInProgress) {
      this.refreshInProgress = true;

      if (!this.authService.isAuthenticated()) {
        this.router.navigate(['/auth/login']);
        subscriber.complete();
        this.requests = [];
        this.refreshInProgress = false;
        return;
      }

      this.authService.renewAuth().subscribe(
        (authHeader) => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.setItem('access_token', authHeader.accessToken);
          localStorage.setItem('refresh_token', authHeader.refreshToken);
          this.repeatFailedRequests();
          this.requests = [];
          this.refreshInProgress = false;
        },
        (error) => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          this.router.navigate(['/auth/login']);
          subscriber.complete();
          this.requests = [];
          this.refreshInProgress = false;
        },
      );
    }
  }

  private repeatFailedRequests() {
    this.requests.forEach((requestInfo) => {
      const requestWithNewToken = requestInfo.request.clone({
        headers: requestInfo.request.headers.set(
          'Authorization',
          'Bearer ' + localStorage.getItem('access_token'),
        ),
      });

      this.http.request(requestWithNewToken).subscribe(
        (res) => {
          requestInfo.subscriber.next(res);
        },
        (err) => {
          if (err.status === 401) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            this.router.navigate(['/auth/login']);
          }

          requestInfo.subscriber.error(err);
        },
        () => {
          requestInfo.subscriber.complete();
        },
      );
    });
  }
}
